import ConversationChatBubble from '@berlitz/streamline-icons/lib/regular/21-Messages-Chat-Smileys/03-Conversation/ConversationChatBubble'
import { IPStatus } from '@components/LPCard/Common'
import { LP_STATUS } from '@utils/constants/learningPath'
import React from 'react'
import { FormattedMessage } from 'react-intl'
import { Transition } from 'react-transition-group'
import { IIsActive, ITransitionState } from './interface'
import StatusIndicator from './StatusIndicator'
import { ButtonContainer, ButtonText, CircleButton } from './style'

interface IPButton extends IPStatus, IIsActive {
  booked?: boolean
  isOpen: boolean
  onClickHandler: () => void
}

const Button: React.FC<IPButton> = ({ onClickHandler, status: statusProp, isOpen, isActive = true }) => {
  const status = isActive ? statusProp : LP_STATUS.LOCKED
  const statusText = {
    [LP_STATUS.LOCKED]: 'Live coaching locked',
    [LP_STATUS.UNLOCKED]: 'Live coaching unlocked',
    [LP_STATUS.CUSTOM_BOOKED]: 'Live coaching booked',
    [LP_STATUS.COMPLETE]: 'Live coaching completed!',
  }
  return (
    <Transition in={isOpen} timeout={300}>
      {(state: ITransitionState) => (
        <ButtonContainer state={state} duration={0} isActive={isActive}>
          <CircleButton state={state} status={status} isActive={isActive} onClick={() => isActive && onClickHandler()}>
            <ConversationChatBubble />
            <StatusIndicator status={status} />
          </CircleButton>
          <ButtonText>
            <FormattedMessage id={statusText[status || ''] || statusText[LP_STATUS.LOCKED]} />
          </ButtonText>
        </ButtonContainer>
      )}
    </Transition>
  )
}

export default Button
